import { Toast } from 'vant'
import axios from 'axios'
import qs from 'qs'
import common from '../assets/js/common.js'
// 在config.js文件中统一存放一些公共常量，方便之后维护
import {config} from './config.js'
import Router from '../router/index.js'
// 接口状态
let apiStatus = config.status
// Login-Type   1：微信公众号授权；2：微信小程序授权；3：微信开放平台APP授权；4：手机号登录；5:web
// Client-Type  1：H5（1）；2：小程序（2）；3：APP（登录方式（Login-Type：3、4））；4:web
// 每种客户端有一种或多种登录类型，Login-Type为动态值
let AjaxHeader = {
  'Content-Type': 'application/x-www-form-urlencoded',
  'Login-Type': 1,
  'Client-Type': 1
}
// 添加请求拦截器
axios.interceptors.request.use(function (config) {
  return config
}, function (error) {
  // 请求错误时弹框提示
  return Promise.reject(error)
})
// 添加响应拦截器
axios.interceptors.response.use(function (response) {
  // 如果只需要返回体中数据，则如下，如果需要全部，则 return response 即可
  return response.data
}, function (error) {
  return Promise.reject(error)
})
// 封装数据返回失败提示函数
function errorState (response) {
  // 如果http状态码正常，则直接返回数据
  if (response.response && (response.response.status === 200)) {
    // 如果不需要除了data之外的数据，可以直接 return response.data
    return response
  } else {
    switch (response.request.status) {
    // switch (response.response.status) {
      case 0:
        break
      case 400:
        Toast('错误请求')
        break
      case 401:
        Toast('未授权，请重新登录')
        break
      case 403:
        Toast('拒绝访问')
        break
      case 404:
        Toast('请求错误，未找到该资源')
        break
      case 405:
        Toast('请求方法为允许')
        break
      case 408:
        Toast('请求超时')
        break
      case 500:
        Toast('服务器端出错')
        break
      case 501:
        Toast('网络未实现')
        break
      case 502:
        Toast('网络错误')
        break
      case 503:
        Toast('服务不可用')
        break
      case 504:
        Toast('网络超时')
        break
      case 505:
        Toast('http版本不支持该请求')
        break
      default:
        Toast('网络出现问题，请稍后再试')
    }
  }
}
// 封装axios
function apiAxios (method, url, params, config) {
  // 加载
  if (config && config.isLoading == true) {
    Toast.loading({
      message: '加载中...',
      forbidClick: true
    })
  }
  // nGv - false 没有版本号
  let URL
  if (config && config.nGv == false) {
    URL = common.URLProxy(url)
  } else {
    URL = common.URLProxy(url, common.GV)
  }
  // var paramsObj = {}
  // paramsObj.hebzh = 10
  // var newObj = Object.assign(paramsObj, params)
  let httpDefault = {
    method: method,
    baseURL: common.GRoot,
    url: URL,
    params: method === 'GET' || method === 'DELETE' ? params : null,
    data: method === 'POST' || method === 'PUT' ? qs.stringify(params, { indices: false }) : null,
    timeout: 6000,
    headers: AjaxHeader,
    emulateJSON: true
  }
  return new Promise((resolve, reject) => {
    axios(httpDefault)
      .then((res) => {
        // 清除加载提示
        if (res) {
          Toast.clear()
        }
        // 统一判断后端返回的错误码
        if (res.code == 10001) {
          // 未登录
          common.ckLogin(res.is_login)
        } else if (res.code === -888) {
          // -888 如果是init接口返回数据  其他返回base页面
          if (url == common.initUrl) {
            return resolve(res)
          } else {
            Router.replace({name: 'base'})
          }
        } else if (res.code === 10000) {
          // 请求成功返回数据
          return resolve(res.data)
        } else if (res.code === -999) {
          // -999 错误提示
          Toast({
            message: res.message,
            duration: 60000
          })
        } else if (apiStatus[res.code]) {
          // 接口错误提示
          Toast(apiStatus[res.code])
        } else {
          if ((config && config.nGv == false) || (config && config.errData == true)) {
            return resolve(res)
          } else {
            Toast(res.message)
          }
        }
      }).catch((response) => {
        reject(response)
        errorState(response)
      })
  })
}
export default {
  install: function (Vue) {
    Vue.prototype.getAxios = (url, params, config) => apiAxios('GET', url, params, config)
    Vue.prototype.postAxios = (url, params, config) => apiAxios('POST', url, params, config)
    Vue.prototype.putAxios = (url, params, config) => apiAxios('PUT', url, params, config)
    Vue.prototype.delectAxios = (url, params, config) => apiAxios('DELECT', url, params, config)
  }
}



// WEBPACK FOOTER //
// ./src/api/axios.js